import { type IAreaTicket } from '../../../models/area-ticket-model';
import { LanguageService } from '../../../services/language.service';
import AreaTicketApiModel from '../AreaTicket/models/area-ticket.api-model';
import AreaTicket from '../AreaTicket';
import { ConfigurationService } from '../../../services/configuration.service';
import { TranslationService } from '../../../services/translation.service';
import Spinner from '../../Shared/Spinner';
import useFetch, { Status } from '../../../hooks/fetch.hook';

// === FUNCTIONS ===
function processReceivedData(data: AreaTicketApiModel): IAreaTicket {
  return AreaTicketApiModel.mapToBusinessModel(data);
}

function AreaTicketDetails() {
  // === CONSTANTS ===
  const translationTicketNotFound = TranslationService.get('areaticketpage.ticketnotfound');
  const areaTicketGuid = ConfigurationService.get('areaticketdetailspage.areaticketguid');

  // === STATE ===
  const [{ status: getMatchingAreaTicketDetailsStatus, data: getMatchingAreaTicketDetailsData }] = useFetch<AreaTicketApiModel>(
    `/api/areatickets/${areaTicketGuid}?language=${LanguageService.getCurrentLanguage()}`
  );
  // === VARAIBLES ===
  const areaTicketDetails = getMatchingAreaTicketDetailsData !== undefined ? processReceivedData(getMatchingAreaTicketDetailsData) : undefined;

  return (
    <div className="area-ticket-details-components">
      {getMatchingAreaTicketDetailsStatus === Status.loading && <Spinner />}

      {getMatchingAreaTicketDetailsStatus === Status.failed && (
        <div>
          <h3 className="m-0 text-center">{translationTicketNotFound}</h3>
        </div>
      )}

      {getMatchingAreaTicketDetailsStatus !== Status.loading && getMatchingAreaTicketDetailsData !== null && (
        <div>
          {areaTicketDetails && (
            <div className="mb-3 mb-md-4">
              <AreaTicket areaTicket={areaTicketDetails} isDetailsPage={true}></AreaTicket>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default AreaTicketDetails;
